import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles({
  imageMargin: {
    paddingRight: '0px',
  },
});
